import React from 'react';
import GroupForm from '../../../../../../../../../../components/forms/Group';

const Active = ({ group, onSave, ...rest }) => {
    return <GroupForm onSubmit={onSave} group={group} {...rest} />;
};

export default Active;
